import makeApiCall from "./axiosIndex";
const taxMasterApis = {
  fetchTaxWithPagination: (params: any): Promise<any> => {
    return makeApiCall({
      url: "/buyer/fetchTaxWithPagination",
      method: "get",
      params,
    });
  },
  fetchTaxDropDown: (taxType?: string): Promise<any> => {
    return makeApiCall({
      url: "/buyer/fetchTaxDropDown",
      method: "get",
      params: taxType ? { taxType } : undefined,
    });
  },

  fetchTaxById: (id: number): Promise<any> => {
    return makeApiCall({
      url: `/buyer/fetchTaxById`,
      method: "get",
      params: { id },
    });
  },

  updateTaxById: (id: number, data: any): Promise<any> => {
    return makeApiCall({
      url: `/buyer/updateTaxById`,
      method: "put",
      params: { id },
      data,
    });
  },

  createTax: (data: any): Promise<any> => {
    return makeApiCall({
      url: `/buyer/createTax`,
      method: "post",
      data,
    });
  },

  deleteTaxById: (id: number): Promise<any> => {
    return makeApiCall({
      url: "/buyer/deleteTaxById",
      method: "delete",
      params: { id },
    });
  },
};

export default taxMasterApis;
